module.exports = __webpack_public_path__ + "static/media/s3-bottom-left-3.70528f89.png";